import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import '../../css/card.css';
import '../../css/global.css';
import { menuImageErrorHander } from '../../functions/errorHander';
import { ORANGE_STAR } from '../../paths/defaultImage';
import AddToCart from '../button/addToCart';
import LazyImage from './lazyLoad';

export default function Card(props) {
  const {
    name,
    image,
    imageType,
    description,
    allPrices,
    cardPadding,
    itemCode,
    isCustomizable,
    showBestSellerTag,
  } = props;
  const { t } = useTranslation();
  const restarantSettingFromRedux = useSelector((state) => state.restSetting?.Setting);
  const customCustomizableText =
    restarantSettingFromRedux?.settings?.custom_text?.menu_customization || t('customizable_text');
  const showItemCode = itemCode && (restarantSettingFromRedux?.settings?.menu?.item_code & 2) === 2;
  const currentSymbol = useSelector((state) => state.restSetting?.Setting?.curr_sym);
  const [showDesc, setShowDesc] = useState(false);
  const [openItemOptions, setOpenItemOptions] = useState(false);
  const showImage = imageType == 0 ? true : false;

  const AddToCartDiv = (
    <AddToCart
      openItemOptions={openItemOptions}
      setOpenItemOptions={setOpenItemOptions}
      isHome={true}
      item={props}
      allPrices={allPrices}
      imageUrl={props.imageUrl}
      itemName={props.name}
      itemId={props.id}
      variations={props.variations}
      addOnId={props.addOnId}
      availability={props.availability}
      itemStatus={props.itemStatus}
      restaurantId={restarantSettingFromRedux.id}
      from={props.from}
      recsType={props.recsType}
      explicitlyTriggerRecs={props?.explicitlyTriggerRecs}
    />
  );

  const PriceData = (
    <div className='mt-2'>
      <div className='fs-14 fw-400 '>
        <span className={`${allPrices?.priceCut ? 'colorDisable' : ''}`}>
          {currentSymbol} {allPrices?.offeringPriceText}
        </span>
        {allPrices?.priceCut ? `${currentSymbol} ${allPrices?.priceCutText}` : ''}
      </div>
      {isCustomizable ? <div className='fs-11 opacity-05'>{customCustomizableText}</div> : null}
    </div>
  );

  const AddDesc = (
    <div className='d-flex'>
      <div className='name_desc'>
        {showBestSellerTag && (
          <div className='bestseller-tag'>
            <LazyImage src={ORANGE_STAR} alt='WhiteStar' width={9} height={9} />
            Bestseller
          </div>
        )}
        <div className='break-word fs-16 fw-500 text-capitalize'>
          {showItemCode ? `(${itemCode}) ${name}` : name}
        </div>
        {description && (
          <div
            onClick={() => {
              setShowDesc(!showDesc);
            }}
            className='description fs-12 fw-300 break-word'>
            {showDesc ? description : description.slice(0, 80)}
            {description.length > 80 ? (
              <span className='red-color'>{showDesc ? t('less_text') : t('more_text')}</span>
            ) : null}
          </div>
        )}
      </div>
      {showImage && <div className='menu-add'>{AddToCartDiv}</div>}
    </div>
  );

  return (
    <>
      {showImage && (
        <div
          className={`cardMenu row ${
            cardPadding || 'pt-3'
          }  mx-0 d-flex no-flex-wrap justify-content-between gap-2`}>
          <div className=' cardItem d-flex flex-column justify-content-between flex-2'>
            {AddDesc}
            {PriceData}
          </div>
        </div>
      )}
      {!showImage && (
        <div
          className={`cardMenu withImage mb-30 row ${
            cardPadding || 'pt-3'
          }  mx-0 d-flex no-flex-wrap justify-content-between gap-2`}>
          <div className=' cardItem d-flex flex-column justify-content-between flex-2'>
            {AddDesc}
            {PriceData}
          </div>
          <div className='cardItem centerContentColumn'>
            <div className='cartImageButton d-flex align-items-end justify-content-center'>
              <LazyImage
                className={props.availability ? 'cardImage' : 'cardImage gray-scale-img'}
                onError={menuImageErrorHander.bind(this)}
                src={image?.image_175x175}
                alt={name}
                width='100%'
                onClick={() => setOpenItemOptions(true)}
              />
              <div className='cardButtonAction '>{AddToCartDiv}</div>
            </div>
          </div>
        </div>
      )}
      {!props.isLastElementOfMenu && <div className='dotted-line w-100' />}
    </>
  );
}
